class TcGoogleAddressController {
  constructor($element, $scope, $window, $timeout) {
    "ngInject";
    this.$element = $element;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.autocomplete = null;
  }

  $onInit() {
    this.checkGoogleMaps();
  }

  checkGoogleMaps() {
    if (this.$window.google && this.$window.google.maps && this.$window.google.maps.places) {
      this.$timeout(() => this.initializeAutocomplete(), 0);
    } else {
      // Wait a bit and check again
      this.$timeout(() => this.checkGoogleMaps(), 100);
    }
  }

  initializeAutocomplete() {
    if (this.autocomplete) {
      return;
    }

    // Get the input element from the component template
    const inputElement = this.$element[0].querySelector('input');
    if (!inputElement) {
      // Try again after a short delay
      this.$timeout(() => this.initializeAutocomplete(), 50);
      return;
    }

    const options = this.options || {};
    
    // Use the legacy Autocomplete API (simple and reliable)
    const autocompleteOptions = {
      types: options.types || ['address'],
      componentRestrictions: options.componentRestrictions || null,
    };

    // Create the autocomplete instance
    this.autocomplete = new this.$window.google.maps.places.Autocomplete(inputElement, autocompleteOptions);

    // Listen for place selection
    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      
      if (!place.geometry) {
        // User entered something that wasn't selected from the dropdown
        // Just update the model with what they typed
        this.$scope.$apply(() => {
          this.ngModel = inputElement.value;
        });
        return;
      }

      // Update the ngModel with the formatted address
      this.$scope.$apply(() => {
        this.ngModel = place.formatted_address || inputElement.value;
      });

      // Call optional callback if provided
      if (this.onPlaceSelected) {
        this.onPlaceSelected({ place: place });
      }
    });

    // Sync input changes to ngModel (for manual typing)
    inputElement.addEventListener('input', () => {
      if (this.$scope.$$phase || this.$scope.$root.$$phase) {
        this.ngModel = inputElement.value;
      } else {
        this.$scope.$apply(() => {
          this.ngModel = inputElement.value;
        });
      }
    });

    // Watch for disabled state changes
    this.$scope.$watch(() => this.disabled, (newVal) => {
      if (inputElement) {
        inputElement.disabled = !!newVal;
      }
    });

    // Watch for ngModel changes from outside (to update the input)
    this.$scope.$watch(() => this.ngModel, (newVal) => {
      if (inputElement && inputElement.value !== newVal) {
        inputElement.value = newVal || '';
      }
    });
  }

  $onDestroy() {
    if (this.autocomplete && this.$window.google && this.$window.google.maps) {
      // Clear all event listeners
      this.$window.google.maps.event.clearInstanceListeners(this.autocomplete);
      this.autocomplete = null;
    }
  }
}

export default TcGoogleAddressController;



// WEBPACK FOOTER //
// ./client/common/directives/google-address-autocomplete/tc-google-address.controller.js